import React, { useState, useEffect } from 'react';
// import './AccidentVehicle.css';
// import '../Location2/Location2.css'
import '../../../Component/CompanyAdmin/Location2/Location2.css';
import axios from '../../../axiosInstance';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import EditAccidentVehicle from '../EditAccidentVehicle/EditAccidentVehicle'
import DataTable from "react-data-table-component";
import Admin from '../AdminHome/SideBar/Admin';
import { Search, Download } from "lucide-react";
import { exportToExcel } from '../../../Services/exportToExcel';

const formatDate = (isoDateString) => {
  const date = new Date(isoDateString);
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getUTCFullYear();
  return (`${day}-${month}-${year}`);
}

const parseDate = (dateString) => {
  const [day, month, year] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day); // Months are 0-indexed in JavaScript
};


const AccidentVehicle = () => {
  const [data, setData] = useState([]);
  const [marginLeft, setMarginLeft] = useState('30px');
  const [paddingLeft, setPaddingLeft] = useState('30px');
  const [width, setWidth] = useState('100%');
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const [showEditAccidentVehicle, setShowEditAccidentVehicle] = useState(false)
  const [selectedId, setSelectedId] = useState(null);



  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowsSelected = (state) => {
    setSelectedRows(state.selectedRows);
  }

  const conditionalRowStyles = [
    {
      when: (row) => selectedRows.some(selected => selected.CustomerCode === row.CustomerCode),
      style: {
        backgroundColor: '#bdb6b6',
      },
    }
  ];

  const tableCustomStyles = {
    headRow: {
      style: {
        color: '#ffff',
        backgroundColor: 'rgb(169 187 169)',
        fontWeight: "bold",
        fontSize: '13px'
      },
    },
    pagination: {
      style: {
        button: {
          background: 'none',
          boxShadow: "none"
        },
      },
    },
    striped: {
      style: {
        default: 'red'
      }
    },
    rows: {
      style: {
        backgroundColor: '#f2f2f2',
      }
    }
  }

  useEffect(() => {
    if (!showEditAccidentVehicle) getData("partiallyAssigned");
    if (token === "" || userId === "") {
      navigate("/");
    }
  }, [token, userId, navigate, showEditAccidentVehicle]);

  const getData = async (getFilteredData) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/getVehicleToAssignVendor/${getFilteredData}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });
    const fetchedData = response.data.data;
    const formattedData = fetchedData.map(item => ({
      ...item,
      systemDate: formatDate(item.systemDate),
    }));
    console.log("formattedData", formattedData)
    setData(formattedData);
    setCurrentItems(formattedData);
  };

  const handleClick = (item) => {
    setSelectedItem(item);
    getData(item);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prevState => ({
  //     ...prevState,
  //     [name]: value
  //   }));
  // };

  const view = (id) => {
    setSelectedId(id);
    setShowEditAccidentVehicle(true)
    // navigate("../EditAccidentVehicle", { state: { id } });
  };

  const handleUpdate = () => {
    setShowEditAccidentVehicle(false); // Hide VendorMasterEdit
  };

  const [currentItems, setCurrentItems] = useState(data);
  console.log("ok this is curentlid", currentItems)
  const columns = [
    {
      name: "Date",
      selector: (row) => row.systemDate,
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const dateA = parseDate(rowA.systemDate);
        const dateB = parseDate(rowB.systemDate);
        return dateA - dateB; // Ascending order
      },
    },
    {
      name: "Customer Name", selector: (row) => row.CustomerName, sortable: true, width: "150px",
      cell: (row) => (
        <span style={{ color: 'blue' }}>{row.CustomerName.charAt(0).toUpperCase() + row.CustomerName.slice(1)}</span>
      )
    },
    {
      name: "Accident File No", selector: (row) => row.accidentFileNo, sortable: true, width: "200px",
      cell: (row) => (
        <span style={{ color: 'brown' }}>{row.accidentFileNo.charAt(0).toUpperCase() + row.accidentFileNo.slice(1)}</span>
      )
    },
    {
      name: "Vehicle No", selector: (row) => row.vehicleNo, sortable: true,
      cell: (row) => (
        <span style={{ color: '#fff', backgroundColor: 'lightblue', padding: '5px', borderRadius: '4px' }}>
          {/* {row.vehicleNo ? row.vehicleNo.charAt(0).toUpperCase() + row.vehicleNo.slice(1).toLowerCase() : ""} */}
          {row.vehicleNo ? row.vehicleNo.toUpperCase() : ""}

        </span>
      ),
    },
    {
      name: "Selected Services", selector: (row) => row.selectedOptions, sortable: true, width: "300px",
      cell: (row) => (
        <span style={{ color: 'blue', padding: '5px 20px 5px 20px' }}>
          {row.selectedOptions
            ? row.selectedOptions
              .split(',')
              .map((option, index) => (
                <React.Fragment key={index}>
                  {index + 1}. {option.trim().charAt(0).toUpperCase() + option.trim().slice(1).toLowerCase()}
                  <br />
                </React.Fragment>
              ))
            : ""}
        </span>
      ),
    },
    {
      name: "Choosen Plan",
      selector: (row) => row.choosenPlan || '',
      sortable: true,
      cell: (row) => {
        const choosenPlan = row.choosenPlan ? String(row.choosenPlan) : "";
        return (
          <span style={{ color: "green" }}>
            {choosenPlan.charAt(0).toUpperCase() + choosenPlan.slice(1).toLowerCase()}
          </span>
        );
      },
    },

    {
      name: "Actions",
      cell: (row) => (
        <button
          onClick={() => view(row.AccidentVehicleCode)}
          className='view-button'
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();

    const newRows = data.filter((row) => {
      const dateValue = (formatDate(row.systemDate) ?? '').toLowerCase().includes(searchValue);
      const customerNameValue = (row.CustomerName ?? '').toLowerCase().includes(searchValue);
      const vehicleNoValue = (row.vehicleNo ?? '').toLowerCase().includes(searchValue);
      const selectedOptionsValue = (row.selectedOptions ?? '').toLowerCase().includes(searchValue);
      const choosenPlanValue = (row.choosenPlan ?? '').toLowerCase().includes(searchValue);

      return dateValue || customerNameValue || vehicleNoValue || selectedOptionsValue || choosenPlanValue;
    });

    setCurrentItems(newRows);
  };

  const [searchValue, setSearchValue] = useState('');

  const [filterType, setFilterType] = useState('fullyAssigned');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    console.log('handleSubmit calling: ')
    setIsLoading(true);
    // setIsGenerated(false);

    console.log({

      filter: filterType,
      from: fromDate,
      to: toDate
    })

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/getWholeDetailsForAdmin`, {

        filter: filterType,
        from: fromDate,
        to: toDate
      });
      const fetchedData = response.data.data;
      console.log('==============')
      console.log(fetchedData)

      const formattedData = fetchedData.map(item => ({
        ...item,
        systemDate: item.systemDate ? formatDate(item.systemDate) : "",

      }));

      // console.log(formattedData)
      // setData(formattedData);
      setCurrentItems(formattedData);

    } catch (error) {
      console.log(error)
    }

  };

  const handleExport = () => {
    // Export only selected rows if any, otherwise export all current items
    const exportData = selectedRows.length > 0 ? selectedRows : currentItems;
    // console.log(currentItems)
    exportToExcel(exportData, "Report");
  };

  return (
    <div style={{marginTop: "-20px"}}>
      <Admin />
      {!showEditAccidentVehicle && (<div className="Customer-master-form" style={{ marginLeft: '10px', paddingLeft: '0px', marginRight: '10px', paddingRight: '0px' }}>
        <Helmet>
          <title>Accident Vehicle Service - Claimpro</title>
          <meta name="description" content="Accident Vehicle Service." />
          <meta name="keywords" content="Vehicle Accidents, accident trucks, Customer Service, Claimpro, Claim pro Assist, Claimpro Assist, Accidental repair, Motor Insurance claim, Advocate services, Hydra Crane service, On site repair, Accident Management" />
          <link rel='canonical' href={`https://claimpro.in/AccidentVehicle`} />
        </Helmet>
  
        <div style={{marginTop: "-35px"}}>
          <h3 className="bigtitle ms-5 container">Assign Vendor to Accident Vehicle</h3>

          <div className='container ms-5 mt-3' >
            <style>
              {`
                                                              .form-search {
                                                                  display: flex;
                                                                  flex-wrap: wrap;
                                                                  gap: 10px;
                                                              }
                  
                                                              @media (max-width: 768px) {
                                                                  .form-search {
                                                                  gap: 3px;
                                                                  //   padding-right: 25px; /* ✅ Add spacing on right side */
                                                                  margin-right: 25px; /* ✅ Add spacing on right side */
                                                                  //   padding-left: -5px;  /* (Optional) to center more nicely */
                                                                  }
                  
                                                                  .form-search > div {
                                                                  flex: 1 1 100% !important;
                                                                  min-width: 100% !important;
                                                                  }
                                                              }
                                                  `}
            </style>

            <div >
              {/* Embedded CSS for responsiveness */}
              <style>
                {`
                      .form-search {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 10px;
                      }
                    
                      @media (max-width: 768px) {
                        .form-search {
                          gap: 3px;
                        //   padding-right: 25px; /* ✅ Add spacing on right side */
                          margin-right: 25px; /* ✅ Add spacing on right side */
                        //   padding-left: -5px;  /* (Optional) to center more nicely */
                        }
                    
                        .form-search > div {
                          flex: 1 1 100% !important;
                          min-width: 100% !important;
                        }
                      }
                    `}
              </style>


              {/* <h3 className="bigtitle">Sign-up Vendor</h3> */}

              <div className="form-search flex">

                {/* Search */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Search by
                    <input
                      type="search"
                      className="form-control-sm border ps-3"
                      placeholder="Search"
                      // value={searchValue}
                      onChange={handleSearch}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Filter Dropdown */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    Filter:
                    <select
                      className="form-control-sm border ps-2"
                      value={filterType}
                      onChange={e => setFilterType(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <option value="fullyAssigned ">Fully Assigned</option>
                      <option value="partiallyAssigned">Partially Assigned</option>
                      <option value="notAssigned">Not Assigned</option>
                    </select>
                  </label>
                </div>

                {/* From Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    From:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={fromDate}
                      onChange={e => setFromDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* To Date */}
                <div style={{ flex: '1 1 200px', minWidth: '200px' }}>
                  <label className="label-class" style={{ width: '100%' }}>
                    To:
                    <input
                      type="date"
                      className="form-control-sm border ps-2"
                      value={toDate}
                      onChange={e => setToDate(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </label>
                </div>

                {/* Buttons */}
                <div className='flex  gap-2 '>

                  {/* <Search
                            className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-gray-600"
                          />
        
                          <Download
                            className="w-6 h-6 text-gray-600 cursor-pointer transition-transform transform hover:scale-125 hover:text-blue-600"
                          /> */}

                  <button onClick={handleSubmit}>
                    <Search className="w-6 h-6 text-gray-600" />
                  </button>
                  <button onClick={handleExport}>
                    <Download className="w-6 h-6 text-gray-600" />
                  </button>
                </div>

              </div>

            </div>

          </div>

        </div>
        {/* <div style={{ display: "flex", margin: "10px" }}>
          <p className={`topdivs ${selectedItem === "fullyAssigned" ? "selected" : ""}`} onClick={() => handleClick("fullyAssigned")}>Fully Assigned </p>
          <p className={`topdivs ${selectedItem === "partiallyAssigned" ? "selected" : ""}`} onClick={() => handleClick("partiallyAssigned")}  >Partially Assigned </p>
          <p className={`topdivs ${selectedItem === "NotAssigned" ? "selected" : ""}`} onClick={() => handleClick("NotAssigned")}>Not Assigned </p>

        </div> */}


        <div className="container d-flex justify-content-center " >
          <div className="container-for-tables my-4">
            <DataTable
              columns={columns}
              data={currentItems}
              keyField="AccidentVehicleCode"
              fixedHeader
              pagination
              selectableRows
              onSelectedRowsChange={handleRowsSelected}
              conditionalRowStyles={conditionalRowStyles}
              customStyles={tableCustomStyles}
            />
          </div>
        </div>

      </div>)}
      {showEditAccidentVehicle && (
        <EditAccidentVehicle id={selectedId} onUpdate={handleUpdate} />
      )}
    </div>
  );
};

export default AccidentVehicle;
